import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@carbon/react';
import cx from 'clsx';

import { formatArea, formatNumeric } from 'utils/format';
import styles from 'theme/features/dashboard/components/specialty-spaces-breakdown-table.module.scss';

const SpecialtySpacesBreakdownTable = ({ specialtySpaces, breakdown, projectSpecialtySpaces, measurementSystem }) => {
  const includedSpecialtySpaceIds = new Set(projectSpecialtySpaces?.map((x) => x.specialtySpaceId));

  const rows = [
    {
      key: 'area',
      title: 'Area',
      format: (value) => formatArea(value, measurementSystem)
    },
    {
      key: 'seats',
      title: 'Seats',
      format: formatNumeric
    }
  ];

  return (
    <Table size="sm">
      <TableHead>
        <TableRow>
          <TableHeader />
          {specialtySpaces.map((x) => (
            <TableHeader key={x.id} className={cx(!includedSpecialtySpaceIds.has(x.id) && styles.excluded)}>
              {x.name}
            </TableHeader>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map(({ title, key, format }) => (
          <TableRow key={key}>
            <TableCell>
              <strong>{title}</strong>
            </TableCell>
            {specialtySpaces.map((space) => {
              const values = breakdown.find((b) => b.specialtySpaceId === space.id);

              return (
                <TableCell key={space.id} className={cx(!includedSpecialtySpaceIds.has(space.id) && styles.excluded)}>
                  {format(values?.[key]) ?? '0'}
                </TableCell>
              );
            })}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default SpecialtySpacesBreakdownTable;
